module.exports = __webpack_public_path__ + "0c94ac7062e8fade5d33513bcdfaf70d.pdf";